import FloatingPanel from 'components/on_board/FloatingPanel/FloatingPanel';
import { VendorOnboardContext } from 'components/on_board/vendor/VendorOnboardProvider/VendorOnboardProvider';
import AffiliationConfirmation from './AffiliationConfirmation/AffiliationConfirmation';
import CreateNewOrgFields from './CreateNewOrgFields/CreateNewOrgFields';
import FindOrCreateOrganization from './FindOrCreateOrganization/FindOrCreateOrganization';
import style from './CompanyAssignmentWizard.module.scss';

const COL_SIZE_HASH_MAP = {
  confirm_affiliation: {},
  no_org_match: { xl: 10 },
  create_org: {},
};

const CompanyAssignmentWizard = () => {
  return (
    <VendorOnboardContext.Consumer>
      {({ currentStepName, currentOrgStep, updateOnboardStep, updateOrgId, setProperty, vendorOrg, progress, newVendorOrgParams, userParams }) => (
        <FloatingPanel colSizes={COL_SIZE_HASH_MAP[currentOrgStep]}>
          <div className={style.vendorOrganizationWizard} id='vendor-organization-wizard'>
            {currentOrgStep === 'confirm_affiliation' && (
              <AffiliationConfirmation
                currentStepName={currentStepName}
                setProperty={setProperty}
                updateOnboardStep={updateOnboardStep}
                userParams={userParams}
                vendorOrg={vendorOrg}
              />
            )}
            {currentOrgStep === 'no_org_match' && (
              <FindOrCreateOrganization
                setOrgStep={setProperty}
                updateOnboardStep={updateOnboardStep}
              />
            )}
            {currentOrgStep === 'create_org' && (
              <CreateNewOrgFields
                currentStepName={currentStepName}
                isFreeEmail={userParams.isFreeEmail}
                newVendorOrgParams={newVendorOrgParams}
                progress={progress}
                setProperty={setProperty}
                updateOnboardStep={updateOnboardStep}
                updateOrgId={updateOrgId}
              />
            )}
          </div>
        </FloatingPanel>
      )}
    </VendorOnboardContext.Consumer>
  );
};

export default CompanyAssignmentWizard;
